import { openComponentInPopup, QueryParameter } from "./common";
import Form from "./form";
import { PopupWidth } from "./popup";
import { trackGenerateLead } from "./analytics";

export class ProductSampleInquiryForm {
    private componentName: string = 'ProductSampleInquiryForm';
    // Popup wrapper id; the form inside it is #inquiry-form. Merchant scripts and CSS select both ids.
    private componentId: string = 'product-sample-inquiry-form';
    private productId: number;

    constructor(productId: number) {
        this.productId = productId;
    }

    async openInPopup(event: Event, queryParameters: QueryParameter[] = null): Promise<void> {
        event?.preventDefault();

        await openComponentInPopup(this.componentName, queryParameters, { id: this.componentId, width: PopupWidth.Medium }, true);
        this.subscribeForm();
    }

    private subscribeForm(): void {
        const formElement = document.querySelector('[data-popup] form') as HTMLFormElement;
        const actionUrl = formElement.getAttribute('action');
        const url = `${actionUrl}/${this.productId}`;

        const form = new Form(url, formElement,
            () => this.onSuccess('product-sample-inquiry-form', url),
            (html: string) => this.onModelError(html));

        form.subscribeAndProcess();
    }

    private onSuccess(formId: string, formDestination: string): void {
        this.displaySuccessMessage();
        trackGenerateLead(formId, formDestination);
    }

    private onModelError(html: string): void {
        const viewcomponent = document.querySelector(`[data-component=${this.componentName}]`);
        viewcomponent.innerHTML = html;
        this.subscribeForm();
    }

    private displaySuccessMessage(): void {
        const successMessageElement = document.getElementById('success-message');
        const form = document.querySelector('#product-sample-inquiry-form #inquiry-form') as HTMLElement;

        successMessageElement.style.display = 'block';
        form.style.display = 'none';
    }
}
